module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/packages/yofoui/customized/upload/asset/upload.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/packages/yofoui/customized/upload/asset/upload.png
// module id = 1062
// module chunks = 418